import { keccak256, toBytes, toHex } from "viem";

// MST-<year>-<eventId>-<8 hex chars of keccak256(eventId, wallet)>. Derived only from
// (eventId, wallet) — the same pair the contract's hasMinted() enforces uniqueness on
// — so it never depends on a client-predicted tokenId and can never collide between two
// concurrent mints for different wallets, even when both read the same totalMinted().
export const buildCertificateId = (eventId, wallet, year = new Date().getFullYear()) => {
  const digest = keccak256(toBytes(`${eventId}:${wallet.toLowerCase()}`)).slice(2, 10);
  return `MST-${year}-${eventId}-${digest}`;
};

export const buildCertificatePayload = ({
  participantName,
  eventId,
  eventName,
  venue,
  organizer,
  certificateId,
  issueDate,
  wallet
}) => ({
  n: participantName,
  e: eventId,
  en: eventName,
  v: venue,
  o: organizer,
  c: certificateId,
  d: issueDate,
  w: wallet
});

// Hash must be computed identically here and in the verification page, and must
// match what was passed to mintCertificate() on-chain.
export const hashCertificatePayload = (payload) => {
  const canonical = JSON.stringify(payload, Object.keys(payload).sort());
  return keccak256(toBytes(canonical));
};

export const encodeVerificationData = (payload) => {
  const json = JSON.stringify(payload);
  const base64 =
    typeof window !== "undefined"
      ? window.btoa(unescape(encodeURIComponent(json)))
      : Buffer.from(json, "utf-8").toString("base64");
  return encodeURIComponent(base64);
};

export const decodeVerificationData = (encoded) => {
  try {
    const base64 = decodeURIComponent(encoded);
    const json =
      typeof window !== "undefined"
        ? decodeURIComponent(escape(window.atob(base64)))
        : Buffer.from(base64, "base64").toString("utf-8");
    return JSON.parse(json);
  } catch (err) {
    return null;
  }
};

export const buildVerificationUrl = (certificateId, payload) => {
  const origin =
    typeof window !== "undefined" ? window.location.origin : "https://newsite.mstblockchain.com";
  const data = encodeVerificationData(payload);
  return `${origin}/nft-minting/verify/${encodeURIComponent(certificateId)}?d=${data}`;
};

export { toHex };
